import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { TestTypeEntity } from './test-type.model';

/* eslint-disable @typescript-eslint/no-shadow */
export enum TestTypeActionTypes {
  LoadTestTypes = '[TestType] Load TestTypes',
  AddTestType = '[TestType] Add TestType',
  UpsertTestType = '[TestType] Upsert TestType',
  AddTestTypes = '[TestType] Add TestTypes',
  UpsertTestTypes = '[TestType] Upsert TestTypes',
  UpdateTestType = '[TestType] Update TestType',
  UpdateTestTypes = '[TestType] Update TestTypes',
  DeleteTestType = '[TestType] Delete TestType',
  DeleteTestTypes = '[TestType] Delete TestTypes',
  ClearTestTypes = '[TestType] Clear TestTypes',
}
/* eslint-enable @typescript-eslint/no-shadow */

export class LoadTestTypes implements Action {
  public readonly type = TestTypeActionTypes.LoadTestTypes;

  constructor(public payload: { testTypes: TestTypeEntity[] }) {}
}

export class AddTestType implements Action {
  public readonly type = TestTypeActionTypes.AddTestType;

  constructor(public payload: { testType: TestTypeEntity }) {}
}

export class UpsertTestType implements Action {
  public readonly type = TestTypeActionTypes.UpsertTestType;

  constructor(public payload: { testType: TestTypeEntity }) {}
}

export class AddTestTypes implements Action {
  public readonly type = TestTypeActionTypes.AddTestTypes;

  constructor(public payload: { testTypes: TestTypeEntity[] }) {}
}

export class UpsertTestTypes implements Action {
  public readonly type = TestTypeActionTypes.UpsertTestTypes;

  constructor(public payload: { testTypes: TestTypeEntity[] }) {}
}

export class UpdateTestType implements Action {
  public readonly type = TestTypeActionTypes.UpdateTestType;

  constructor(public payload: { testType: Update<TestTypeEntity> }) {}
}

export class UpdateTestTypes implements Action {
  public readonly type = TestTypeActionTypes.UpdateTestTypes;

  constructor(public payload: { testTypes: Update<TestTypeEntity>[] }) {}
}

export class DeleteTestType implements Action {
  public readonly type = TestTypeActionTypes.DeleteTestType;

  constructor(public payload: { id: string }) {}
}

export class DeleteTestTypes implements Action {
  public readonly type = TestTypeActionTypes.DeleteTestTypes;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearTestTypes implements Action {
  public readonly type = TestTypeActionTypes.ClearTestTypes;
}

export type TestTypeActions =
  | LoadTestTypes
  | AddTestType
  | UpsertTestType
  | AddTestTypes
  | UpsertTestTypes
  | UpdateTestType
  | UpdateTestTypes
  | DeleteTestType
  | DeleteTestTypes
  | ClearTestTypes;
